jQuery(document).ready(function(jQuery) {

  jQuery('.mini-cart').on('click', function (e) {
    jQuery('#cart-sidebar').addClass("active");
    jQuery('.overlay').addClass("active");
  });
  
  function cart_sidebar_open() {
    //console.log('cart_sidebar_open');
    jQuery('#cart-sidebar').addClass("active");
    jQuery('#cart-sidebar').addClass("_loading");
    jQuery('.overlay').addClass("active");
  };

  
  jQuery('.cart-sidebar-close, .overlay').on('click', function (e) {
    jQuery('#cart-sidebar').removeClass('active');
    jQuery('.overlay').removeClass("active");
  });



  jQuery('.add-to-cart').on('click',function(e){
    cart_sidebar_open();
    var form = jQuery(this).closest('form');
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function(cart) { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
        jQuery('.cart-sidebar-error-message').show();
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        cart_sidebar_update();
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();
        
      
      }
    });
    e.preventDefault();
    
  });

  
  
  
  
  function cart_sidebar_update(){
      jQuery.getJSON('/cart.js', function(cart){
      //console.log(cart);
      cart_sidebar_update_mini_cart(cart);
      cart_sidebar_update_free_shipping(cart);
      cart_sidebar_update_product(cart);
      cart_sidebar_update_totals(cart);
      jQuery('#cart-sidebar').removeClass("_loading");
      jQuery('#cart-sidebar').removeClass("is_empty");
        
        if (cart.item_count == 0) {
          jQuery('#cart-sidebar').addClass("is_empty");
        }
              
    });
  };
  
  function cart_sidebar_update_mini_cart(cart) {
    jQuery('.mini-cart .cart-count').html('('+cart.item_count+')');
  }
  function cart_sidebar_update_free_shipping(cart) {
    
    var free_shipping_price = parseInt(window.free_shipping_price );
    var free_shipping_qualified = window.free_shipping_vault_text;
    
    var free_shipping_away = 0;
    var cart_total_price =  parseInt(cart.total_price) / 100;
    var free_shipping_bar = Math.round((cart_total_price * 100)/free_shipping_price);
    if (cart_total_price >= free_shipping_price) {
      jQuery('.ajax-cart-free-shipping .progress-bar').css('width', '100%');
      jQuery('.ajax-cart-free-shipping h3').text(free_shipping_qualified);
    } else {
      free_shipping_away = parseInt(free_shipping_price - cart_total_price);
      jQuery('.ajax-cart-free-shipping h3').html("$<span>"+free_shipping_away.toFixed(2)+"</span> Away from free shipping");
      jQuery('.ajax-cart-free-shipping .progress-bar').css('width', free_shipping_bar+'%');
    }
  }
  
  function cart_sidebar_update_product(cart) {
    jQuery('.cart-sidebar-products h5 span').text(cart.item_count);
    var template = '<li class="__cart_sidebar_item __cart_sidebar_{ID}" data-id="{ID}"><div class="cart-sidebar-product-image"><a href="{URL}"><img src="{IMAGE}" loading="lazy" width="55"/></a></div><div class="cart-sidebar-product-details"><a href="{URL}">{NAME}</a><span><span>{OLD_PRICE}</span> {PRICE}</span>{DISCOUNT}{OPTION}<div class="__product-qty"><span class="qty_minus">-</span><input type="number" name="quantity" class="cart_sidebar_qty" data-id="{ID}" data-max="{MAX}" value="{QUANTITY}"/><span class="qty_plus">+</span></div></div><div class="cart-sidebar-product-remove" data-id="{ID}"><svg width="50px" height="50px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><path d="M20 18h2v16h-2z"/><path d="M24 18h2v16h-2z"/><path d="M28 18h2v16h-2z"/><path d="M12 12h26v2H12z"/><path d="M30 12h-2v-1c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v1h-2v-1c0-1.7 1.3-3 3-3h4c1.7 0 3 1.3 3 3v1z"/><path d="M31 40H19c-1.6 0-3-1.3-3.2-2.9l-1.8-24 2-.2 1.8 24c0 .6.6 1.1 1.2 1.1h12c.6 0 1.1-.5 1.2-1.1l1.8-24 2 .2-1.8 24C34 38.7 32.6 40 31 40z"/></svg></div></li>';
    var ProductList = jQuery('.cart-sidebar-products ul');
    if (cart.item_count > 0) {
      for(var i = 0; i < cart.items.length; i++) {
        var _price = cart.items[i].original_price;
        var discounted_price = cart.items[i].discounted_price;

        if(_price != discounted_price){
          var price=Shopify.formatMoney(cart.items[i].discounted_price);
          var old_price=Shopify.formatMoney(cart.items[i].original_price);
          var discount_title=cart.items[i].discounts[0]['title'];
          var discount_html = '<ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg> '+discount_title+' </li></ul>';
        } else {
          var old_price='';
          var price=Shopify.formatMoney(cart.items[i].original_price);
          var discount_html= '';
          
        }


        var option_html = '';
        if(cart.items[i].options_with_values){
          for(var p = 0; p < cart.items[i].options_with_values.length; p++) {
               if(cart.items[i].options_with_values[p].value!="Default Title"){
                 option_html = '<p class="product-option">'+cart.items[i].options_with_values[p].name+': '+cart.items[i].options_with_values[p].value+'</p>';
               }
          }
        }
        
        
        if (i == 0) {
          ProductList.html('');
        }
        var item = template;
        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{URL\}/g, cart.items[i].url);
        item = item.replace(/\{NAME\}/g, cart.items[i].product_title);  
        item = item.replace(/\{OPTION\}/g, option_html);
        item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title || '');
        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(/\{IMAGE\}/g, cart.items[i].image);
        item = item.replace(/\{OLD_PRICE\}/g, old_price);
        item = item.replace(/\{PRICE\}/g, price);
        item = item.replace(/\{DISCOUNT\}/g, discount_html);
        item = item.replace(/\{MAX\}/g, 24);
        ProductList.append(item);
      }
    
    } else {
      ProductList.html('');
      jQuery('#cart-sidebar').addClass("is_empty");
    }
    
  
  }
  function cart_sidebar_update_totals(cart) {
   jQuery('.cart-sidebar-totals span').html(Shopify.formatMoney(cart.total_price));
   jQuery('.cart-sidebar-footer a span').html(Shopify.formatMoney(cart.total_price));

    
  }
  
  function cart_sidebar_update_quantity(product_id,quantity){
    cart_sidebar_open();
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity='+quantity+'&id='+product_id,
      dataType: 'json',
      success: function() { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
	    jQuery('.cart-sidebar-error-message').show();
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        cart_sidebar_update();
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();

      }
    });
  }
  
  jQuery(document).delegate(".cart_sidebar_qty", "change", function(e) {
    var product_id = jQuery(this).attr('data-id');
    var quantity = jQuery(this).val();
    cart_sidebar_update_quantity(product_id,quantity);
   
  });
  
  
  jQuery(document).delegate(".__product-qty .qty_plus", "click", function(e) {
      var old_val = jQuery(this).parent().find("input").val();
      var max_val = jQuery(this).parent().find("input").attr('data-max');
      var product_id = jQuery(this).parent().find("input").attr('data-id');
      if ( parseFloat(old_val) >= 1 && parseFloat(old_val) < max_val) {
        var new_val = parseFloat(old_val) + 1;
        jQuery(this).parent().find("input").val(new_val);
        var quantity = new_val;
        cart_sidebar_update_quantity(product_id,quantity);
      }
  });
  
  
  jQuery(document).delegate(".__product-qty .qty_minus", "click", function(e) {
      var old_val = jQuery(this).parent().find("input").val();
      var product_id = jQuery(this).parent().find("input").attr('data-id');
      if ( parseFloat(old_val) > 0) {
        var new_val = parseFloat(old_val) - 1;
        jQuery(this).parent().find("input").val(new_val);
        var quantity = new_val;
        cart_sidebar_update_quantity(product_id,quantity);
      }
  });
  
  
  
   jQuery(document).delegate(".cart-sidebar-product-remove", "click", function(e) {
    cart_sidebar_open();
    var product_id = jQuery(this).attr('data-id');
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + product_id,
      dataType: 'json',
      success: function() { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();    
      }
    });
    
    e.preventDefault();
    
  });
  
  

  jQuery('.swatch-option').on('click', function(){
     var type = jQuery(this).data("type");
     var value = jQuery(this).data("value");
     jQuery(this).closest('.swatch-attribute-options').children('.swatch-option').removeClass('selected');
     jQuery(this).addClass('selected');
     jQuery(this).closest('.swatch-attribute').children('.swatch-attribute-selected-option').text(jQuery(this).children('label').text());
      
   });


  jQuery(document).delegate(".select_qty .plus_btn", "click", function(e) {
      var old_val = jQuery(this).parent().find("input").val();
      var max_val = jQuery(this).parent().find("input").attr('data-max');
      if ( parseFloat(old_val) >= 1 && parseFloat(old_val) < max_val) {
        var new_val = parseFloat(old_val) + 1;
        jQuery(this).parent().find("input").val(new_val);
        var quantity = new_val;
      }
  });
  
  
  jQuery(document).delegate(".select_qty .minus_btn", "click", function(e) {
      var old_val = jQuery(this).parent().find("input").val();
      if ( parseFloat(old_val) > 0) {
        var new_val = parseFloat(old_val) - 1;
        jQuery(this).parent().find("input").val(new_val);
        var quantity = new_val;
      }
  });



  


});                    